{
  "EMOJI": {
    "PLACEHOLDER": "搜尋表情符號",
    "NOT_FOUND": "找不到符合的表情符號",
    "REMOVE": "移除"
  }
}
